import React from 'react';
import classes from './ThirdNav.module.scss';
import classNames from 'classnames';
import { useTopNavVisibility } from '../../hooks/useTopNavVisibility';
import { useScrolling } from '../../hooks/useScrolling';
import { ThirdNavChildrenType } from './ThirdNav.controller';

export type ThirdNavViewProps = {
  secondNavVisibility: boolean;
  thirdNav: ThirdNavChildrenType | null;
};

export const ThirdNavView = (props: ThirdNavViewProps): JSX.Element => {
  const scrolling = useScrolling();
  const centreNavOnly = props.thirdNav?.center && !props.thirdNav?.right && !props.thirdNav?.left;

  const navClass = classNames(
    props.secondNavVisibility ? classes.ThirdNavWithSecond : classes.ThirdNavWithTop,
    classes.ThirdNav,
    {
      [classes.ThirdNavScrolling]: scrolling,
      [classes.ThirdNavCenterOnly]: centreNavOnly
    }
  );

  const navContainerClasses = classNames({
    cell: true,
    'small-12': true,
    'margin-bottom-small-8': true,
    'margin-bottom-tablet-portrait-16': true,
    'margin-top-small-8': true,
    'margin-top-tablet-portrait-16': true
  });

  useTopNavVisibility('third');

  return (
    <>
      {props.thirdNav && (
        <div className={navClass}>
          <div className={navContainerClasses}>
            <div className={'grid-y align-justify'}>
              <div className={'grid-x align-justify'}>
                <div className={props.thirdNav.left && props.thirdNav.center && classes.LeftContentWithCenter}>
                  {props.thirdNav.left}
                </div>
                <div className={classes.CenterContent}>{props.thirdNav.center}</div>
                <div>{props.thirdNav.right}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
